import { css } from 'linaria';
import { theme } from '../../Theme';

export const cartTextItemStyle = css`
  ${theme.fonts.desktop.p1}
  color: ${theme.colors.darkgrey};
`;
